/*****
 * Created by Allan on 2021/04/28.
 * Contact 84880528@qq.com.
 * *****/
import Http from '@/services/http/'
import {REMOVE_TAGS} from "./tagsview";
export const APP_LIST='APP_LIST';
export default{
    state:{
        applist:JSON.parse(localStorage.getItem('applist')) || [],
        onApplist:JSON.parse(localStorage.getItem('onApplist')) || [],  //在线APP
        offApplist:JSON.parse(localStorage.getItem('offApplist')) || [],  //下架APP
    },
    getters:{
        applist:state=>state.applist,
        onApplist:state=>state.onApplist,
        offApplist:state=>state.offApplist,
    },
    mutations:{
        [APP_LIST](state,data){
            localStorage.setItem('applist',JSON.stringify(data));
            state.applist=data;
        },
        mutationsOnApplist(state,data){
            localStorage.setItem('onApplist',JSON.stringify(data));
            state.onApplist=data;
        },
        mutationsOffApplist(state,data){
            localStorage.setItem('offApplist',JSON.stringify(data));
            state.offApplist=data;
        },
    },
    actions:{
        [APP_LIST]({commit, state}){
            return Http('/appInfo/appList',{method:'post',data:{},reqType:'json'}).then(res=>{
                console.log('appInfo/appList====>',res)
                let onAppdata=[],  //在线APP
                    offAppdata=[];  //下架APP
                if(res.data.length!==0){
                    res.data.filter(item=>{
                        item.state='onLine';
                        onAppdata.push(item);
                    })
                    commit('mutationsOnApplist',onAppdata);
                    commit('mutationsOffApplist',offAppdata);
                }
                console.log('res.datares.data',res.data)
                commit(APP_LIST,res.data);
            })
        },
    },
}




// WEBPACK FOOTER //
// ./src/store/applist.js